import React, { forwardRef } from 'react';
export const AlertText = (StyledAlertText) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledAlertText ref={ref} {...props}>
        {children}
      </StyledAlertText>);
});
